import { getMexicoDateString } from './dateUtils'
import { clubCapturaEsteTorneo } from './torneoOrigen'

// Si el roster de esta inscripcion admite cambios, POR FECHA O POR CIERRE. No sabe de
// mundos: eso lo decide `limitesDeRoster`, y la pantalla junta las dos respuestas.
//
// Se calculaba con new Date().toISOString().slice(0, 10), que es UTC. En Mexico
// (UTC-6) eso devuelve la fecha de MAÑANA a partir de las 18:00 hora local: la noche
// antes del dia limite el roster se cerraba solo.
export const rosterCongelado = (inscripcion, torneo, hoy = getMexicoDateString()) => {
  if (inscripcion?.roster_estado === 'cerrado') return true
  const limite = torneo?.fecha_limite_roster || null
  return Boolean(limite) && hoy > limite
}

// Que limites de roster aplican en este torneo PARA ESTE CLUB (2026-09-06).
//
// El dueno: "los torneos internos no deben tener limites de roster: cualquier grupo
// puede inscribirse y agregar juegos". En el torneo interno el organizador es el
// propio club, asi que una fecha limite, un cierre o un tope serian del club contra
// si mismo, y "Solicitar cambio" seria pedirse permiso a uno mismo. Los limites son de
// la organizadora de la red, que pone reglas a clubes que no son ella.
//
// Antes esto era verdad por accidente (el formulario del torneo interno nunca pide
// esas reglas, asi que las columnas quedaban vacias); ahora es regla, aqui y en la
// base (20260906_torneos_internos_sin_limites_de_roster). Sin org conocida se contesta
// conservador: los limites aplican; la base decide de todos modos.
export const limitesDeRoster = (torneo, orgId) => {
  if (clubCapturaEsteTorneo(torneo, orgId)) {
    return { congelable: false, tope: null }
  }
  return { congelable: true, tope: torneo?.max_jugadores_grupo || null }
}
